/**
 * JeriCommerce Pass API · staging
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 202609.29.01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Reward { 
    id: string;
    code: string;
    value: number;
    /**
     * Points needed to redeem. For dynamic rewards, the minimum points per redemption.
     */
    cost: number;
    type: Reward.TypeEnum;
    /**
     * Dynamic rewards: discount amount per redeemed point.
     */
    currencyPerPoint?: number | null;
    /**
     * Dynamic rewards: minimum points per redemption.
     */
    minPoints?: number | null;
    /**
     * Dynamic rewards: maximum points per redemption.
     */
    maxPoints?: number | null;
    title: string;
    description: string;
    image: string;
    redeemable: boolean;
    minimumSpend?: number;
    discountType: Reward.DiscountTypeEnum;
    nonRedeemableReason?: Reward.NonRedeemableReasonEnum;
}
export namespace Reward {
    export type TypeEnum = 'fixed' | 'dynamic';
    export const TypeEnum = {
        Fixed: 'fixed' as TypeEnum,
        Dynamic: 'dynamic' as TypeEnum
    };
    export type DiscountTypeEnum = 'fixed' | 'percentage' | 'free_shipping' | 'buy_x_get_y';
    export const DiscountTypeEnum = {
        Fixed: 'fixed' as DiscountTypeEnum,
        Percentage: 'percentage' as DiscountTypeEnum,
        FreeShipping: 'free_shipping' as DiscountTypeEnum,
        BuyXGetY: 'buy_x_get_y' as DiscountTypeEnum
    };
    export type NonRedeemableReasonEnum = 'COST_HIGHER_THAN_BALANCE' | 'MAX_REDEMPTION_TIMES_REACHED' | 'NOT_ENOUGH_BALANCE' | 'DATES_RULE_NOT_MET' | 'POINTS_ON_HOLD' | 'SEGMENT_RULE_NOT_MET';
    export const NonRedeemableReasonEnum = {
        CostHigherThanBalance: 'COST_HIGHER_THAN_BALANCE' as NonRedeemableReasonEnum,
        MaxRedemptionTimesReached: 'MAX_REDEMPTION_TIMES_REACHED' as NonRedeemableReasonEnum,
        NotEnoughBalance: 'NOT_ENOUGH_BALANCE' as NonRedeemableReasonEnum,
        DatesRuleNotMet: 'DATES_RULE_NOT_MET' as NonRedeemableReasonEnum,
        PointsOnHold: 'POINTS_ON_HOLD' as NonRedeemableReasonEnum,
        SegmentRuleNotMet: 'SEGMENT_RULE_NOT_MET' as NonRedeemableReasonEnum
    };
}


